import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["component", "imageProps", "childComponents", "options", "textBlockBanners", "hasTextBlockBanners", "siblings"];
import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '@blaze-cms/core-errors-ui';
import { useMainContext } from '@blaze-cms/nextjs-components';
import getComponent from './getComponent';
import getVariant from './getVariant';
import appendGtmClassName from './append-gtm-classname';
import { PB_TYPE_IMAGE, PB_TYPE_BANNER, PB_TYPE_TEXTBLOCK, PB_TYPE_CAROUSEL } from './constants';
import { BannerContextProvider } from '../../BannerContext';
import { PbWrapper } from '../../system-components';
const RenderComponent = _ref => {
  let {
      component,
      imageProps,
      childComponents,
      options = {},
      textBlockBanners,
      hasTextBlockBanners,
      siblings
    } = _ref,
    nestedComponentsProps = _objectWithoutProperties(_ref, _excluded);
  const {
    debugOptions: {
      editorModeEnabled
    } = {}
  } = useMainContext();
  const {
    type,
    settings,
    id,
    name
  } = component;
  const Component = getComponent(type);
  const isImage = [PB_TYPE_IMAGE, PB_TYPE_BANNER, PB_TYPE_TEXTBLOCK, PB_TYPE_CAROUSEL].includes(type);
  const imageOptions = isImage ? imageProps : {};
  if (!Component) return null;
  const updatedSettings = appendGtmClassName(settings, childComponents);
  const [VariantComponent, variantSettings] = getVariant(settings);
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, editorModeEnabled && /*#__PURE__*/React.createElement(PbWrapper, {
    name: name
  }), /*#__PURE__*/React.createElement(Component, _extends({
    key: id,
    type: type,
    VariantComponent: VariantComponent
  }, options, imageOptions, nestedComponentsProps, updatedSettings, variantSettings, {
    name: name || settings.name
  }), hasTextBlockBanners ? /*#__PURE__*/React.createElement(BannerContextProvider, {
    siblings: siblings,
    banners: textBlockBanners,
    pbOptions: options
  }, childComponents) : childComponents), editorModeEnabled && /*#__PURE__*/React.createElement(PbWrapper, {
    name: name,
    type: "end"
  }));
};
RenderComponent.propTypes = {
  component: PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    settings: PropTypes.object,
    items: PropTypes.array
  }).isRequired,
  imageProps: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  childComponents: PropTypes.node.isRequired,
  textBlockBanners: PropTypes.array,
  hasTextBlockBanners: PropTypes.bool,
  siblings: PropTypes.array
};
RenderComponent.defaultProps = {
  textBlockBanners: null,
  hasTextBlockBanners: false,
  siblings: []
};
export default RenderComponent;
//# sourceMappingURL=RenderComponent.js.map